import { z } from 'zod';
import { CrewClaimTypeEnum } from '../../enums/crew.js';
import { enumToZodLiteralUnion, helperSchema } from '../../zodExtensions.js';
import { claimAddress } from './address.js';
import { appliedCustomField, appliedCustomFieldCreate } from './customField.js';
import { storeOrderLineItem } from './lineItem.js';
import { registrationProductVariant } from './storeProduct.js';
export const registration = z.object({
    id: z.number(),
    externalId: z.string(),
    customerProvidedOrderNumber: z.string().optional(),
    createdOn: z.string(),
    customFields: z.array(appliedCustomField).optional(),
    estimatedPurchaseDate: z.string().nullish(),
    registrationChannelName: z.string(),
    proofOfPurchaseFileUrls: z.array(z.string()),
    emailMarketingConsentCollectedOn: z.string().optional(),
    claims: z.array(z.object({
        id: z.number(),
        externalId: z.string(),
        claimType: enumToZodLiteralUnion(CrewClaimTypeEnum),
    })),
    firstName: z.string(),
    lastName: z.string(),
    // ! properties that live on the order
    orderIdFromPlatform: z.string(),
    address: claimAddress.optional(),
    lineItems: z.array(storeOrderLineItem),
    email: z.string(),
    orderNumber: z.string().optional(),
    referrer: helperSchema.optionalizedString,
    canceledOn: z.string().optional(),
    kobjectIdFromPlatform: z.string().optional(),
});
export const registrationUpdate = registration
    .pick({
    estimatedPurchaseDate: true,
    address: true,
})
    .merge(z.object({
    storeProductVariants: z
        .array(z.object({
        idFromPlatform: z.string(),
        quantity: z.number(),
    }))
        .optional(),
    lineItemIdToRemove: z.number().optional(),
}));
export const registrationListItem = registration
    .pick({
    registrationChannelName: true,
    createdOn: true,
    externalId: true,
    id: true,
    canceledOn: true,
})
    .merge(z.object({
    customerEmail: z.string(),
    customerName: z.string().nullable(),
}));
export const registrationList = z.array(registrationListItem);
export const registrationCreate = registration
    .omit({
    claims: true,
    externalId: true,
    orderIdFromPlatform: true,
    createdOn: true,
    registrationChannelName: true,
    proofOfPurchaseFileUrls: true,
    estimatedPurchaseDate: true,
    id: true,
    lineItems: true,
    customFields: true,
})
    .merge(z.object({
    firstName: z.string(),
    lastName: z.string(),
    storeProductVariants: z.array(registrationProductVariant
        .pick({
        id: true,
    })
        .merge(z.object({ quantity: z.number() }))),
    storeSalesChannelId: z.number(),
    estimatedPurchaseDate: z.string(),
    proofOfPurchaseFilenames: z.array(z.string()).optional(),
    customFields: z.array(appliedCustomFieldCreate),
}));
//# sourceMappingURL=registration.js.map